import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Copy, Check } from "lucide-react";
import { Prism as SyntaxHighlighterBase } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { tokens } from "@/theme/tokens";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SyntaxHighlighter = SyntaxHighlighterBase as any;

export interface CodeBlockProps {
  language?: string;
  value: string;
}

export function CodeBlock({ language, value }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Box sx={{ position: "relative", my: 1 }}>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton
          size="small"
          onClick={onCopy}
          sx={{ position: "absolute", top: 4, right: 4, zIndex: 1 }}
          aria-label="copy code"
        >
          {copied ? <Check size={14} /> : <Copy size={14} />}
        </IconButton>
      </Tooltip>
      <SyntaxHighlighter
        language={language ?? "text"}
        style={oneDark}
        customStyle={{ borderRadius: tokens.radius.md, margin: 0, boxShadow: tokens.shadow.md }}
      >
        {value}
      </SyntaxHighlighter>
    </Box>
  );
}
